import * as React from 'react';

import { LazyLoadingPage } from 'components';

interface Opts {
  fallback: React.ReactNode;
}
type Unpromisify<T> = T extends Promise<infer P> ? P : never;

export const lazyLoad = <
  T extends Promise<any>,
  U extends React.ComponentType<any>
>(
  importFunc: () => T,
  selectorFunc?: (s: Unpromisify<T>) => U,
  opts: Opts = { fallback: <LazyLoadingPage /> }
) => {
  let lazyFactory: () => Promise<{ default: U }> = importFunc;

  if (selectorFunc) {
    lazyFactory = () =>
      importFunc().then(module => {
        return { default: selectorFunc(module) };
      });
  }

  const LazyComponent = React.lazy(lazyFactory);

  return (props: React.ComponentProps<U>): JSX.Element => (
    <React.Suspense fallback={opts.fallback!}>
      <LazyComponent {...props} />
    </React.Suspense>
  );
};
